import { Link, Tooltip } from '@mui/material'
import React, { useContext } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { Context } from './PayslipsTableFrame-component'
import { useClipboard } from 'use-clipboard-copy'
import { RootState } from 'redux/store'

import { IMAGES_PATH } from 'themes'
const CopyImg = IMAGES_PATH(`/copy-icon.svg`)

interface IProps {
    tableHeader: string
    clipboardProp?: string
}

export const PayslipsTableHeader: React.FC<IProps> = props => {
    const { t } = useTranslation()
    const { classes } = useContext(Context)

    const {
        acquiring: { cardAcquiringMerchants },
    } = useSelector((state: RootState) => state)

    const clipboard = useClipboard({
        copiedTimeout: 2000,
    })

    const handleClipboardClick = event => {
        event.preventDefault()
        clipboard.copy(JSON.stringify(cardAcquiringMerchants[props.clipboardProp]))
    }

    return (
        <div data-sta-id={`simple-table-frame-component-div-${props.tableHeader}`} className={classes.tableCardHeader}>
            <div>{t(`${props.tableHeader}`)}</div>
            {!!props.clipboardProp && (
                <Tooltip
                    data-clipboardtarget
                    title={clipboard.copied ? `${t('HeaderComponent.Copied!')}` : `${t('HeaderComponent.Copy')}`}
                    placement="top"
                    arrow={true}
                    className={classes.tableCardHeaderCopy}
                    enterDelay={0}
                    enterTouchDelay={0}
                >
                    <span>
                        <img onClick={e => handleClipboardClick(e)} data-clipboardtarget src={CopyImg} alt={t('HeaderComponent.CopyID')} />
                    </span>
                </Tooltip>
            )}
        </div>
    )
}
